import { OrderStatus } from '@/resources/enums'

export const COLOR_BY_STATUS = {
  POC_REJECT: '#888888',
  POC_ACCEPTED: '#1A7028',
  POC_EXPIRED: '#C3352B',
  POC_PICKED_UP: 'rgba(68,107,196,1)',
  CS_CANCELLEDOC: '#888888',
  DELIVERED: '#1A7028',
}

export const HEXA_COLORS = {
  GREEN: 'var(--primitive-solid-green-80)',
  ORANGE: 'var(--primitive-solid-orange-80)',
  BLUE: 'var(--primitive-solid-blue-80)',
  RED: 'var(--primitive-solid-red-80)',
  BLACK: 'var(--primitive-solid-neutral-100)',
}

export const TYPE_BY_STATUS: Record<OrderStatus, string> = {
  CS_CANCELLEDOC: 'error',
  DELIVERED: 'success',
  DM_ACCEPTED: 'warning',
  DM_CANCELLATION_REQUEST: 'error',
  DM_EN_ROUTE: 'info',
  DM_EXPIRED: 'error',
  DM_PICKED_UP: 'info',
  DM_REJECT: 'error',
  PENDING: 'progress',
  POC_ABANDONED: 'error',
  POC_ACCEPTED: 'warning',
  POC_EXPIRED: 'error',
  POC_PICKED_UP: 'info',
  POC_REJECT: 'error',
  SUSPECT: 'error',
  TRANSFERED: 'progress',
  USER_CANCELLED: 'error',
  POC_SCHEDULED: 'progress',
}

export const TEXT_COLOR_BY_STATUS: Record<OrderStatus, string> = {
  DELIVERED: HEXA_COLORS.GREEN,
  POC_ACCEPTED: HEXA_COLORS.ORANGE,
  DM_ACCEPTED: HEXA_COLORS.ORANGE,
  DM_EN_ROUTE: HEXA_COLORS.BLUE,
  DM_PICKED_UP: HEXA_COLORS.BLUE,
  POC_PICKED_UP: HEXA_COLORS.BLUE,
  CS_CANCELLEDOC: HEXA_COLORS.RED,
  DM_EXPIRED: HEXA_COLORS.RED,
  DM_CANCELLATION_REQUEST: HEXA_COLORS.RED,
  DM_REJECT: HEXA_COLORS.RED,
  POC_ABANDONED: HEXA_COLORS.RED,
  POC_EXPIRED: HEXA_COLORS.RED,
  POC_REJECT: HEXA_COLORS.RED,
  SUSPECT: HEXA_COLORS.RED,
  USER_CANCELLED: HEXA_COLORS.RED,
  PENDING: HEXA_COLORS.BLACK,
  TRANSFERED: HEXA_COLORS.BLACK,
  POC_SCHEDULED: HEXA_COLORS.BLACK,
}

export const NOTE_KEYWORDS = {
  ROOM_TEMPERATURE: '[PEDIDO EM TEMPERATURA AMBIENTE]',
  HEAVY_BAG: '[PEDIDO GRANDE COM ADICIONAL DE FRETE]',
}
